import { Box, MantineProvider } from "@mantine/core";
import { useEvent } from "event/hooks/useEvent";

type PlayLayoutProps = {
  theme: {
    colors: { background?: string; text?: string; questionText?: string };
    images?: { playBackground: string };
    font?: { fontFace: string };
    position?: string;
  };
  children: React.ReactNode;
};

export function PlayLayout({ theme, children }: PlayLayoutProps) {
  const color = theme?.colors.text || theme?.colors.questionText;
  const backgroundColor = theme?.colors.background;
  const backgroundImage = theme?.images?.playBackground
    ? `url(${theme.images.playBackground})`
    : undefined;
  const backgroundPosition = theme?.position;

  const styles = {
    color,
    backgroundColor,
    backgroundImage,
    backgroundPosition,
  };

  const event = useEvent();

  const fontMappings = {
    virage: "VirageCorporate-Regular",
    poppins: "Poppins-Regular",
    marfa: "Marfa-Regular",
    audi: "Audi-Regular",
    default: "VirageCorporate-Regular",
  };

  const fontFamily = `${fontMappings[event?.font as keyof typeof fontMappings] || fontMappings.default}, sans-serif`;

  return (
    <Box
      className="min-w-screen min-h-screen overflow-hidden bg-auto bg-no-repeat"
      sx={styles}
    >
      <MantineProvider theme={{ fontFamily }}>{children}</MantineProvider>
    </Box>
  );
}
